import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { UserCreatePayload } from '../models/user-create-model';
import { CustomerCreateModel } from '../models/customer-create-model';
import { CustomerServiceCreateModel } from '../models/customer-service-create-model';
import { TransactionCreatePayload } from '../models/transaction-create-model';
import { MetaDataModel } from '../models/transaction-metadata-model';
import { SmsListFilterPayload } from '../models/sms-list-model';

@Injectable({
  providedIn: 'root',
})
export class SmSMasterService {
  constructor(private http: HttpClient) {}

  lFN_GetSmSListFilter(payload: SmsListFilterPayload) {
    return this.http.post(
      `${environment.ROOT_URL}/sms-log/scheduled-sms/filter`,
      payload,
      {
        withCredentials: false,
        responseType: 'text',
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

}
